/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/**
 * API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ApproveManagerRequestNotificationAction } from './ApproveManagerRequestNotificationAction';
import {
    ApproveManagerRequestNotificationActionFromJSON,
    ApproveManagerRequestNotificationActionFromJSONTyped,
    ApproveManagerRequestNotificationActionToJSON,
} from './ApproveManagerRequestNotificationAction';

/**
 * 
 * @export
 * @interface ApproveManagerRequestNotification
 */
export interface ApproveManagerRequestNotification {
    /**
     * 
     * @type {string}
     * @memberof ApproveManagerRequestNotification
     */
    type: string;
    /**
     * 
     * @type {string}
     * @memberof ApproveManagerRequestNotification
     */
    groupId: string;
    /**
     * 
     * @type {boolean}
     * @memberof ApproveManagerRequestNotification
     */
    isSeen: boolean;
    /**
     * 
     * @type {number}
     * @memberof ApproveManagerRequestNotification
     */
    seenAt?: number;
    /**
     * 
     * @type {Array<ApproveManagerRequestNotificationAction>}
     * @memberof ApproveManagerRequestNotification
     */
    actions: Array<ApproveManagerRequestNotificationAction>;
}

/**
 * Check if a given object implements the ApproveManagerRequestNotification interface.
 */
export function instanceOfApproveManagerRequestNotification(value: object): value is ApproveManagerRequestNotification {
    let isInstance = true;
    isInstance = isInstance && "type" in value && value["type"] !== undefined;
    isInstance = isInstance && "groupId" in value && value["groupId"] !== undefined;
    isInstance = isInstance && "isSeen" in value && value["isSeen"] !== undefined;
    isInstance = isInstance && "actions" in value && value["actions"] !== undefined;

    return isInstance;
}

export function ApproveManagerRequestNotificationFromJSON(json: any): ApproveManagerRequestNotification {
    return ApproveManagerRequestNotificationFromJSONTyped(json, false);
}

export function ApproveManagerRequestNotificationFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApproveManagerRequestNotification {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'type': json['type'],
        'groupId': json['group_id'],
        'isSeen': json['is_seen'],
        'seenAt': !exists(json, 'seen_at') ? undefined : json['seen_at'],
        'actions': ((json['actions'] as Array<any>).map(ApproveManagerRequestNotificationActionFromJSON)),
    };
}

export function ApproveManagerRequestNotificationToJSON(value?: ApproveManagerRequestNotification | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'type': value.type,
        'group_id': value.groupId,
        'is_seen': value.isSeen,
        'seen_at': value.seenAt,
        'actions': ((value.actions as Array<any>).map(ApproveManagerRequestNotificationActionToJSON)),
    };
}

